import Wix from './Wix';
import debounce from 'lodash.debounce';

import { TPADeviceType, TPAViewMode } from '@wix/podcasts-common/dist/tpa';

const MIN_WIDTH_MAP = {
  [TPADeviceType.DESKTOP]: 680,
  [TPADeviceType.MOBILE]: 320,
};

function resizeConstraint(minWidth) {
  return (event) => {
    const viewMode = Wix.Utils.getViewMode();
    const newWidth = event.target.innerWidth;

    if (viewMode === TPAViewMode.EDITOR && newWidth < minWidth) {
      Wix.resizeComponent({ width: minWidth });
    }
  };
}

function syncDocumentWidthWithViewer(deviceType: TPADeviceType) {
  const minWidth =
    MIN_WIDTH_MAP[deviceType] || MIN_WIDTH_MAP[TPADeviceType.DESKTOP];

  window.addEventListener('resize', debounce(resizeConstraint(minWidth), 600));
}

export default syncDocumentWidthWithViewer;
